import { Link } from "react-router-dom";

/**
 * Kore wordmark. Renders as SVG-friendly text using the site's sans font
 * (Montserrat 800/500) and inherits `currentColor` so the parent controls colour.
 *
 * variant:
 *   - "stacked": bold KORE above tracked-out WELLBEING (default; matches brand mark)
 *   - "inline":  KORE inline, no subtitle (compact usage)
 * size: sm | md | lg | xl
 */
export default function Logo({
  variant = "stacked",
  size = "md",
  className = "",
  asLink = true,
  ariaLabel = "Kore Wellbeing",
}) {
  const scale = {
    sm: { k: "text-lg", w: "text-[8px] tracking-[0.32em]", gap: "mt-0.5" },
    md: { k: "text-2xl", w: "text-[9px] tracking-[0.36em]", gap: "mt-1" },
    lg: { k: "text-4xl", w: "text-xs tracking-[0.4em]", gap: "mt-1.5" },
    xl: { k: "text-6xl", w: "text-sm tracking-[0.42em]", gap: "mt-3" },
  }[size];

  const body = (
    <span
      role="img"
      aria-label={ariaLabel}
      className={`inline-flex ${variant === "stacked" ? "flex-col items-start" : "items-baseline gap-2"} leading-none select-none ${className}`}
      data-testid="kore-logo"
    >
      <span
        className={`font-sans font-extrabold tracking-[0.05em] ${scale.k}`}
        style={{ fontWeight: 800, letterSpacing: "0.05em" }}
      >
        KORE
      </span>
      {variant === "stacked" ? (
        <span className={`font-sans font-medium uppercase ${scale.w} ${scale.gap} opacity-80`}>
          Wellbeing
        </span>
      ) : (
        <span className="font-sans text-[10px] uppercase tracking-[0.32em] opacity-70">Wellbeing</span>
      )}
    </span>
  );

  return asLink ? (
    <Link to="/" data-testid="nav-logo" className="inline-flex group">
      {body}
    </Link>
  ) : (
    body
  );
}
